<template>
  <div>
    <stepForm
      :user="user"
      :request="request"
      :request-buttons="requestButtons"
      :btn-position="btnPosition"
      @input="$emit('input')"
    >
    </stepForm>
    <div v-if="showHistory" class="mt-3">
      <history-days-off />
    </div>
  </div>
</template>

<script>
import stepForm from '@/components/shared/stepForm';

export default {
  name: 'StepOne',
  components: {
    HistoryDaysOff: () => import('../../abscenceRequest/HistoryDaysOff'),
    stepForm,
  },
  props: ['user'],
  data() {
    return {
      showHistory: true,
    };
  },
  computed: {
    request() {
      const requestData = {
        requestFor: this.$t('days.off.request.for'),
        title: this.$t('days.off.request.step.one.title'),
        description: this.$t('days.off.request.step.one.description'),
        videoUrl: this.$t('days.off.video.url'),
        leftLeaves: this.$t('days.off.request.step.one.left.cp', {
          totalCp: this.user.leftPaidVacations,
        }),
      };
      return requestData;
    },

    requestButtons() {
      const requestBtns = {
        next: this.$t('global.next'),
        // history: this.$t("global.history")
      };
      return requestBtns;
    },

    btnPosition() {
      const buttonStyle = {
        btnHistoryClass: 'btn-wrapper d-flex justify-content-between',
        btnClass: 'ml-md-auto mr-md-0 mx-auto',
      };
      return buttonStyle;
    },
  },
};
</script>

<style scoped>
</style>
